import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  private timezoneSubject = new BehaviorSubject<string>(this.getInitialTimezone());
  selectedTimezone$ = this.timezoneSubject.asObservable();

  private getInitialTimezone(): string {
    const storedTimezone = localStorage.getItem('selectedTimezone');
    if (storedTimezone) {
      return storedTimezone;
    }

    return moment.tz.guess();
  }

  setTimezone(timezone: string) {
    localStorage.setItem('selectedTimezone', timezone);
    this.timezoneSubject.next(timezone);
  }

  public getTimezone(): string {
    return this.timezoneSubject.value;
  }

  convertToStartOfDay(date: Date): Date {
    //Convert for Date range filter
    const timezone = this.getTimezone().replace(/\s*\(GMT[+-]\d+\)$/, '');
    return moment.tz(date, timezone).startOf('day').toDate();
  }

  convertToEndOfDay(date: Date): Date {
    //Convert for Date range filter
    const timezone = this.getTimezone().replace(/\s*\(GMT[+-]\d+\)$/, '');
    return moment.tz(date, timezone).endOf('day').toDate();
  }

  convertDateToTimezone(
    date: Date | string | null | undefined,
    format: string = 'DD/MM/YYYY HH:mm:ss',
  ): string {
    if (!date) return '-';

    const momentDate = moment(date);
    if (!momentDate.isValid()) {
      console.error('Invalid date:', date);
      return '-';
    }

    let selectedTimezone = this.getTimezone().replace(/\s*\(GMT[+-]\d+\)$/, '');

    if (!moment.tz.zone(selectedTimezone)) {
      console.warn(`Timezone "${selectedTimezone}" not found, falling back to UTC`);
      selectedTimezone = 'UTC';
    }

    return momentDate.tz(selectedTimezone).format(format);
  }
  convertDateToTimezoneNoGMT(
    date: Date | string | null | undefined,
    format: string = 'DD/MM/YYYY HH:mm:ss',
    timezone?: string,
  ): string {
    if (!date) return '-';

    const momentDate = moment(date);
    if (!momentDate.isValid()) {
      console.error('Invalid date:', date);
      return '-';
    }

    let selectedTimezone =
      timezone?.replace(/\s*\(.*\)$/, '') || this.getTimezone().replace(/\s*\(.*\)$/, '');

    if (!moment.tz.zone(selectedTimezone)) {
      console.warn(`Timezone "${selectedTimezone}" not found, falling back to UTC`);
      selectedTimezone = 'UTC';
    }

    return momentDate.tz(selectedTimezone).format(format);
  }

  convertDateToTimezoneWithoutGMT(
    date: Date | string | null | undefined,
    format: string = 'DD/MM/YYYY HH:mm:ss',
  ): string {
    if (!date) return '-';

    const momentDate = moment(date);
    if (!momentDate.isValid()) {
      console.error('Invalid date:', date);
      return '-';
    }

    let selectedTimezone = this.getTimezone()?.replace(/\s*\(.*\)$/, '') || 'UTC';

    if (!moment.tz.zone(selectedTimezone)) {
      console.warn(`Timezone "${selectedTimezone}" not found, falling back to UTC`);
      selectedTimezone = 'UTC';
    }

    return momentDate.tz(selectedTimezone).format(format);
  }
}
